import { useNavigate } from 'react-router'
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material'
import { Lottie } from 'lottie-react'

import firstSensorPlacementAnimation from '../../animations/first-sensor-placement.json'
import highFloorCommercialAnimation from '../../animations/high-floor-commercial.json'
import BackButton from '../../components/back-button'
import HelpIconUrl from '../../components/help-icon-url'
import ScreenContainer from '../../components/screen'
import SensorActivationFooter from '../../components/sensor-activation-footer'
import { useActivationContext } from '../../providers/activation-provider'
import { SHORT_SCREEN_HEIGHT } from '../../utils/constants'
import useFolderTheme from '../../utils/hooks/useFolderTheme'

import useStyles from './index.styles'

const HigherFloor = () => {
  const classes = useStyles

  const navigate = useNavigate()

  const { activationLocationState } = useActivationContext()
  const { folderId, nodeTypeName } = activationLocationState
  const { folderTheme } = useFolderTheme(folderId)
  const isShortScreen = useMediaQuery(`(max-height:${SHORT_SCREEN_HEIGHT})`)
  const theme = useTheme()

  const isCommercialLocationType = folderTheme?.locationType === 'Commercial Lines'

  return (
    <ScreenContainer
      useDarkBackground={true}
      headerProps={{
        title: 'Higher floors first',
        showDownloadAppButton: false,
        leftIcon: <BackButton />,
        rightIcon: nodeTypeName === 'leak5s' ? <HelpIconUrl url="https://resources.meshify.com/defender-slim/#highest-floor-placement" /> : undefined,
        useDarkBackground: true,
        progress: 13,
      }}
    >
      <Box sx={classes.animationContainer}>
        <Lottie
          src={isCommercialLocationType ? highFloorCommercialAnimation : firstSensorPlacementAnimation}
          autoplay={true}
          loop={false}
          data-testid="higher-floor-lottie"
        />
      </Box>

      <Typography variant="h6" sx={classes.sidewalkText}>
        For best signal, place your&nbsp;
        <strong>first sensor above ground</strong> - starting on the&nbsp;
        <strong>highest floor</strong> if you can.
      </Typography>

      <Typography variant="body2" sx={classes.descriptionText}>
        If higher floor is not available, choose location near exterior-facing wall.
      </Typography>

      <SensorActivationFooter
        primaryButton={
          <Button variant="contained" disableElevation color="secondary" onClick={() => navigate('/placement-tips', { state: activationLocationState })}>
            Got it — Let’s find a spot
          </Button>
        }
        sxFooter={{
          height: isShortScreen ? 'auto' : undefined,
          paddingBottom: isShortScreen ? theme.spacing(2) : undefined,
        }}
      />
    </ScreenContainer>
  )
}

export default HigherFloor
